var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("vue-folder-button", {
    attrs: {
      tabindex: "0",
      "icon-class": _vm.value ? "fa-eye" : "fa-pencil",
      "aria-label": "Toggle Edit Mode",
      role: "button",
    },
    nativeOn: {
      click: function ($event) {
        return _vm.toggle.apply(null, arguments)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }